import { FormInput, FormInputMoney, FormInputNumber } from "@farzoom/common-ui-components";
import { Col, Row } from "antd"
import { Beneficiaries } from "./Beneficiaries"
import { IKZList } from "./IKZList"
import { ProductsList } from "./productsList"
import { VerticalSpace } from "@app/UI/VerticalSpace"
import { useFormContext } from "react-hook-form";
import { BgFormType } from "@services/guarantees/types";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { memo, useEffect } from "react";
import { ContractConditions } from "./contractConditions";

export const LotFields = memo(({idx}: {idx: number}) => {
  const { control, setValue, getValues } = useFormContext<BgFormType>();
  const { formDisabled, prefix } = useBgFormContext();
  const currentPrefix = (prefix ? `${prefix}.purchase.lots` : "purchase.lots") as "purchase.lots";

  return (
    <VerticalSpace>
      <Row gutter={16}>
        <Col span={4}>
          <FormInputNumber
            name={`${currentPrefix}.${idx}.lotNumber`}
            control={control}
            setValue={setValue}
            label="№ лота"
            controls={false}
            disabled={formDisabled}
            required={!formDisabled}
          />
        </Col>
        <Col span={20}>
          <FormInput
            name={`${currentPrefix}.${idx}.lotSubject`}
            control={control}
            setValue={setValue}
            label="Предмет контракта"
            required={!formDisabled}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <FormInputMoney
            name={`${currentPrefix}.${idx}.startAmount`}
            control={control}
            setValue={setValue}
            label="НМЦК (Начальная (максимальная) цена контракта)"
            controls={false}
            disabled={formDisabled}
            maxLength={25}
            required={!formDisabled}
          />
        </Col>
        <Col span={12}>
          <FormInputMoney
            name={`${currentPrefix}.${idx}.principalOfferAmount`}
            control={control}
            setValue={setValue}
            defaultValue={getValues(`${currentPrefix}.${idx}.startAmount`)}
            label="Предложенная цена контракта"
            controls={false}
            disabled={formDisabled}
            maxLength={25}
            required={!formDisabled}
          />
        </Col>
      </Row>

      <IKZList lotIndex={idx} />
      <ProductsList lotIndex={idx} />
      <ContractConditions lotIndex={idx} />
      <Beneficiaries lotIndex={idx} />
    </VerticalSpace>
  )
})
